/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SessionCheckoutCompleteDtoBase
 * auto generated base class for the model SessionCheckoutCompleteDtoModel.
 */
export const SessionCheckoutCompleteDtoModelBase = ModelBase
  .named('SessionCheckoutCompleteDto')
  .props({
    __typename: types.optional(types.literal("SessionCheckoutCompleteDto"), "SessionCheckoutCompleteDto"),
    status: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SessionCheckoutCompleteDtoModelSelector extends QueryBuilder {
  get status() { return this.__attr(`status`) }
}
export function selectFromSessionCheckoutCompleteDto() {
  return new SessionCheckoutCompleteDtoModelSelector()
}

export const sessionCheckoutCompleteDtoModelPrimitives = selectFromSessionCheckoutCompleteDto().status
